<template>
  <div
    v-if="env.show && isAdminRoute"
    :class="['environment-banner', `environment-banner--${env.level}`]"
    role="status"
    aria-live="polite"
  >
    <span class="environment-banner__dot" />
    <span class="environment-banner__label">{{ env.label }}</span>
    <span class="environment-banner__hint">{{ env.hint }}</span>
  </div>
</template>

<script>
const PROD_HOSTS = new Set(['flex.countly.com']);
const DEV_HOSTS = new Set(['localhost', '127.0.0.1', '0.0.0.0']);

export default {
  name: 'EnvironmentBanner',
  data() {
    return {
      hostname: typeof window !== 'undefined' ? window.location.hostname : '',
    };
  },
  computed: {
    isAdminRoute() {
      const path = (this.$route && this.$route.path) || '';
      return path.startsWith('/admin');
    },
    env() {
      if (PROD_HOSTS.has(this.hostname)) {
        return {
          show: false, level: 'prod', label: 'PROD', hint: '',
        };
      }
      if (DEV_HOSTS.has(this.hostname)) {
        return {
          show: true, level: 'dev', label: 'DEV', hint: this.hostname,
        };
      }
      return {
        show: true, level: 'staging', label: 'STAGING', hint: this.hostname,
      };
    },
  },
};
</script>

<style>
.environment-banner {
  position: fixed;
  top: 88px;
  right: max(40px, calc(50vw - 660px));
  z-index: 10001;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 22px;
  padding: 0 10px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #FFFFFF;
  border-radius: 6px;
  pointer-events: none;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  box-shadow: 0 2px 8px -2px rgba(0, 0, 0, 0.2);
}

.environment-banner--dev {
  background: #f59e0b;
}

.environment-banner--staging {
  background: #8b5cf6;
}

.environment-banner__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 0 6px rgba(255, 255, 255, 0.6);
}

.environment-banner__hint {
  opacity: 0.75;
  font-weight: 500;
  letter-spacing: 0.04em;
  text-transform: none;
}

@media (max-width: 768px) {
  .environment-banner {
    top: 72px;
    right: 8px;
  }
  .environment-banner__hint {
    display: none;
  }
}
</style>
